import { createNode } from '@glueapp/graph-types';

export const Schedule = createNode({
    id: 'Schedule',
    name: 'Schedule',
    description: '',
    aiDescription:
        'Timer-based trigger that fires on a schedule. Configure it headlessly with `set_state <nodeId> time <ScheduleExpression>`, where ScheduleExpression is one of: ' +
        '{"type":"RecurringCronBasedSchedule","cronExpression":"0 9 * * 1-5"} (cron, e.g. 9am Mon–Fri), ' +
        '{"type":"RecurringRateBasedSchedule","unit":"DAY","value":1} (unit ∈ MINUTE|HOUR|DAY|WEEK|MONTH|YEAR), or ' +
        '{"type":"OneTimeSchedule","dateTime":"2026-06-07T09:00:00Z"}. ' +
        'It has no data ports. To make it run an action, wire its execution-flow port to the action: `connect <scheduleNodeId> InherentOut <actionNodeId> InherentIn`.',
    category: 'Trigger',
    isAsync: false,
    color: '#808080',
    inPorts: {},
    outPorts: {},
    triggerType: 'Timer',
    triggerEventIdentifier: 'timerTriggered',
    hideInherentInPort: true,
    interfaceComponentId: 'schedule-editor',
    execute: function (input) {
        return {
            output: {},
        };
    },
});
